
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11586',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11586",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.446",
  "dashboard-client-types": "static-1.233",
  "data-fetching-client": "static-1.9487",
  "foundations-components": "static-1.7541",
  "foundations-components-legacy": "static-1.566",
  "foundations-theming": "static-1.4221",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7815",
  "hub-http-shared-msw-handlers": "static-1.9496",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11242",
  "I18n": "static-7.1572",
  "jasmine-runner": "static-1.6282",
  "marketplace-storefront-base": "static-1.11646",
  "quartz": "static-1.6748",
  "react-dlb": "static-1.72",
  "react-rhumb": "static-1.16460",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2672",
  "reporting-testing-lib": "static-1.8497",
  "settings-ui-lib": "static-1.12332",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6749",
  "ui-addon-i18n": "static-1.10950",
  "ui-addon-react-router-dom": "static-1.9356",
  "unified-auth": "static-1.227",
  "unified-auth-core-lib": "static-1.508",
  "usage-tracker": "static-1.7144",
  "usage-tracker-core": "static-1.6994",
  "customer-data-property-utils": "static-1.7887",
  "history": "static-4.47",
  "hub-http": "static-1.6030",
  "integrations-lib": "static-1.15447",
  "marketplace-ui-common": "static-1.18982",
  "property-management-iframe": "static-1.12382",
  "quartz-config": "static-1.526",
  "quartz-core": "static-1.5967",
  "quartz-routing": "static-1.178",
  "quick-fetch": "static-1.3744",
  "react": "static-7.179",
  "rpc-client-utils": "static-1.4444",
  "ts-schema": "static-1.3913",
  "ui-universal-auth": "static-1.8713",
  "UIComponents": "static-3.8189",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3238",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3025",
  "quartz-webpack": "static-1.2972",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3810",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4646",
  "foundations-theming-specialty": "static-1.1937",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9237",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5182",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1233",
  "ui-fonts": "static-1.504",
  "ui-images": "static-2.1094",
  "bend-plugin-foundations-theming": "static-1.2704",
  "foundations-theming-base": "static-1.3206",
  "stylex": "static-1.27",
  "HeadJS": "static-2.711",
  "hs-test-utils-bend-plugin": "static-1.2926",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4136",
  "ai-components-ui-library": "static-1.8369",
  "ai-rendering-library": "static-1.9333",
  "chirp-fetch": "static-1.1692",
  "connections-embed-lib": "static-1.647",
  "copilot-toolkit": "static-1.10556",
  "laboratory-lib": "static-3.6970",
  "marketplace-embed": "static-1.21510",
  "marketplace-ui-details": "static-1.8878",
  "marketplace-ui-reviews": "static-1.18938",
  "marketplace-ui-tracking": "static-1.13153",
  "sanitize-text": "static-1.7950",
  "ui-addon-video-player": "static-1.8506",
  "usage-tracker-multi": "static-1.5558",
  "usage-tracker-session-replay": "static-1.4830",
  "wootric-nps": "static-1.6793",
  "apollo-link-hub-http": "static-2.4459",
  "immer": "static-1.33",
  "immerable": "static-1.3965",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66564",
  "cssUtils": "static-1.734",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11550",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10019",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10181",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7134",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17515",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4331",
  "foundations-components-test-utils": "static-1.5024",
  "quartz-i18n": "static-1.423",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3541",
  "customer-data-objects": "static-1.7459",
  "property-translator": "static-1.5222",
  "frontend-preferences-client": "static-1.7734",
  "hs-promise-utils": "static-1.5403",
  "hubspot-apollo-client": "static-1.4691",
  "integrations-error-boundary-lib": "static-1.12862",
  "integrations-tracking-lib": "static-1.5398",
  "native-integrations-shared-strings": "static-1.7598",
  "reselect": "static-2.16",
  "sanitize": "static-1.4284",
  "superstore": "static-1.4580",
  "ui-shepherd-react": "static-3.9957",
  "ai-settings-ui-library": "static-1.7472",
  "hub-http-janus": "static-1.796",
  "hubspotter-http": "static-1.4487",
  "immutable-less": "static-1.4464",
  "marketplace-ui-client-types": "static-1.16389",
  "nav-meta": "static-1.28935",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10046",
  "ui-addon-upgrades": "static-9.17675",
  "inbound-db-properties-service-client": "static-1.3684",
  "property-management-common": "static-1.4669",
  "ui-addon-iframeable": "static-1.8854",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.484",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.423",
  "quartz-head": "static-1.413",
  "quartz-test": "static-1.423",
  "quartz-tracking": "static-1.127",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2956",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20358",
  "ContentUtils": "static-1.67651",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2296",
  "customer-data-filters-ui": "static-1.38941",
  "customer-data-objects-ui-components": "static-1.12817",
  "customer-data-reference-ui-components": "static-1.12955",
  "embedded-academy-lib": "static-1.13577",
  "ExportDialog": "static-6.10196",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40681",
  "reporting-snowflake": "static-1.55182",
  "reporting-ui-components": "static-2.63835",
  "reporting-visualizations": "static-1.58640",
  "ui-addon-teams": "static-1.21257",
  "magpie-lib": "static-1.5403",
  "magpie-types": "static-1.4863",
  "simple-logging-lib": "static-1.2860",
  "navigation-components": "static-1.17298",
  "ai-studio-lib": "static-1.11027",
  "developer-experience-shared-components": "static-1.10288",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7799",
  "ui-tool-access": "static-1.9954",
  "usage-based-billing-components-lib": "static-1.8029",
  "usage-tracker-anonymous": "static-1.5561",
  "usage-tracker-public": "static-1.6955",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3426",
  "persist-promise": "static-1.3518",
  "reference-resolvers": "static-1.7970",
  "ui-extensibility-client-types": "static-1.3754",
  "hubspot-apollo-cache": "static-1.150",
  "universal-page-editor-lib": "static-1.2809",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2212",
  "merchandise-lib": "static-1.259",
  "atom": "static-1.4879",
  "purchase-motions-components": "static-1.5495",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1361",
  "crm-component-utils": "static-1.38503",
  "crm-properties-common-lib": "static-1.5682",
  "framework-data-schema-resolvers": "static-1.6683",
  "reference-resolvers-lite": "static-1.7904",
  "navigation-messaging": "static-1.6625",
  "hubspotter-http-shared-msw-handlers": "static-1.9494",
  "cms-field-types": "static-1.4616",
  "content-icons-ui": "static-1.2156",
  "conversations-skeleton-state": "static-1.7057",
  "crm-message-bus": "static-1.42395",
  "customer-data-filters-ui-msw-helpers": "static-1.21376",
  "customer-data-ui-utilities": "static-1.9633",
  "FormUrlGenerator": "static-2.4539",
  "framework-builder-read-service-client": "static-1.3842",
  "framework-data-schema-quick-fetch": "static-1.6588",
  "multi-account-reference-resolvers": "static-1.783",
  "onboarding-tours": "static-1.16275",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13081",
  "academy-common-lib": "static-1.13037",
  "content-assistance-lib": "static-1.7462",
  "dashboard-lib": "static-1.80666",
  "file-manager-components": "static-1.22916",
  "getting-started-shared-tasks": "static-1.17911",
  "hubspot-prosemirror": "static-1.17632",
  "hubspot-prosemirror-plugins": "static-1.17624",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19485",
  "share-with-third-party-component-lib": "static-1.8501",
  "ui-addon-draggable": "static-3.4575",
  "ui-asset-management-lib": "static-1.10723",
  "ui-business-units-lib": "static-1.8838",
  "user-context": "static-1.4909",
  "growth-payments-core": "static-1.24754",
  "reporting-plugins": "static-1.9996",
  "reporting-reports": "static-1.66242",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.535",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28872",
  "react-codemirror": "static-1.10436",
  "apps-service-types": "static-1.3687",
  "oauth-service-types": "static-1.4054",
  "onboarding-scopes": "static-1.6273",
  "onboarding-tours-client": "static-1.4489",
  "platform-infra-nav-components": "static-1.7501",
  "subscription-experience-data-types": "static-1.14598",
  "crm-record-cards-service-types": "static-1.3460",
  "location-customization-utils-lib": "static-1.8591",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4323",
  "nav-client-types": "static-1.2167",
  "purchase-motions-api": "static-1.5498",
  "signup-constants": "static-1.18425",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3724",
  "card-properties-lib": "static-1.43550",
  "crm-actions": "static-1.6112",
  "crm-cards-data": "static-1.1229",
  "crm-cards-sdk": "static-1.42949",
  "customer-data-properties": "static-1.50826",
  "customer-data-properties-shared-msw-handlers": "static-1.8823",
  "customer-data-tracking": "static-1.6692",
  "conditional-properties-service-client": "static-1.3632",
  "crm-pipelines-api-client-types": "static-1.3973",
  "multi-currency-client-types": "static-1.3526",
  "external-options-client-types": "static-1.3993",
  "react-dnd-compat": "static-1.4430",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5168",
  "growth-onboarding-confetti": "static-1.2882",
  "growth-onboarding-next-action-utils": "static-1.1315",
  "onboarding-tours-utils": "static-1.341",
  "ui-shepherd-tracker": "static-1.7338",
  "academy-service-client": "static-1.3490",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27969",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8194",
  "video-components-external": "static-1.10595",
  "video-data-lib": "static-1.34253",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8378",
  "payment-link-components": "static-1.22967",
  "ui-addon-emoji-picker": "static-1.9698",
  "EmailSignatureEditor": "static-1.23929",
  "viral-links-lib": "static-1.6845",
  "data-token-picker": "static-1.16057",
  "FileManagerLib": "static-1.38556",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5054",
  "getting-started-shared-tasks-store": "static-1.17029",
  "campaign-roi-lib": "static-1.8302",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.200",
  "eligibility-engine-service-types": "static-1.3005",
  "crm_data": "static-4.91244",
  "crm-links": "static-1.6076",
  "customer-data-sidebar": "static-2.45444",
  "enrichment-properties-lib": "static-1.15067",
  "crm-fe-perf": "static-1.22715",
  "calling-global-api": "static-1.63704",
  "calling-internal-common": "static-1.31104",
  "calling-lifecycle-internal": "static-1.65086",
  "calling-lifecycle-messages": "static-1.57380",
  "commerce-products-lib": "static-1.8886",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.488",
  "inbounddb-objects-service-types": "static-1.4057",
  "meetings-icalendar-utils-lib": "static-1.443",
  "object-builder-ui-client": "static-1.48010",
  "pipeline-validation-client-types": "static-1.3795",
  "property-value-citations": "static-1.1440",
  "pulse": "static-1.322",
  "smart-property-lib": "static-1.5949",
  "tiered-pricing": "static-1.844",
  "ui-addon-form-validation": "static-1.10804",
  "growth-onboarding-next-action-components": "static-1.1343",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6393",
  "content-media-composition-data-lib": "static-1.11489",
  "content-media-compositions": "static-2.15496",
  "media-bridge-lib": "static-1.18580",
  "commerce-tours-lib": "static-1.5734",
  "growth-onboarding-reliability": "static-1.4896",
  "sales-checkout-service-client": "static-1.3478",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21322",
  "sales-email-signature-service-client": "static-1.3654",
  "audio-components": "static-1.5625",
  "FileManagerCore": "static-1.38415",
  "FileManagerImages": "static-1.36067",
  "video-components": "static-1.12598",
  "crm_universal": "static-1.21675",
  "customer-data-email": "static-1.17685",
  "calling-error-reporting": "static-1.31110",
  "card-payment-highlight-lib": "static-1.36528",
  "card-subscription-highlight-lib": "static-1.38884",
  "commerce-billing-lib": "static-1.18527",
  "commerce-contract-lib": "static-1.11232",
  "customer-data-content": "static-1.26887",
  "invoices-highlight-card-lib": "static-1.54060",
  "orders-highlight-card-lib": "static-1.20891",
  "products-highlight-card-lib": "static-1.17170",
  "project-storage": "static-1.4543",
  "quotes-highlight-card-lib": "static-1.71240",
  "breeze-intelligence-kit": "static-1.5333",
  "crm-source-interpretation-lib": "static-1.5139",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9579",
  "policy-lib": "static-1.6596",
  "shared-worker-versioning": "static-1.10848",
  "calling-usage-tracker": "static-1.6350",
  "voice-sms-access-library": "static-1.275",
  "commerce-permissions": "static-1.568",
  "products-iframe-lib": "static-1.7343",
  "products-ui-components-shared-msw-handlers": "static-1.9878",
  "directed-graph": "static-1.746",
  "event-emitter": "static-1.757",
  "react-tinymce": "static-1.54647",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9642",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53773",
  "tinymce-plugins": "static-1.56887",
  "tinymce-themes": "static-1.55743",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4342",
  "video-embed": "static-1.35087",
  "social-insights-client-types": "static-1.21375",
  "sequences-lib": "static-1.7703",
  "ui-gdpr-components": "static-1.10157",
  "commerce-shared-components-lib": "static-1.17942",
  "commerce-subscription-lib": "static-1.36461",
  "commerce-tools-ui-lib": "static-1.9816",
  "utility-belt": "static-1.2350",
  "payments-enrollment-embed-lib": "static-1.22060",
  "products-ui-components": "static-1.39405",
  "quotes-client-types": "static-1.37329",
  "quotes-ui-lib": "static-1.79960",
  "SalesContentIndexUI": "static-3.8917",
  "accounting-integrations-ui-components": "static-1.6739",
  "invoices-ui-lib": "static-1.54076",
  "commerce-products-api": "static-1.1971",
  "SafeStorage": "static-1.4214",
  "invoices-iframe-lib": "static-1.56134",
  "quotes-modal-lib": "static-1.101917",
  "calling-orchestration-schema": "static-1.35052",
  "sales-views-client-types": "static-1.4097",
  "hub-http-contrib": "static-1.2853",
  "interframe": "static-3.4599",
  "tinymce-data": "static-1.39858",
  "ui-addon-sales-email": "static-1.5023",
  "layout-dnd-components": "static-1.12050",
  "layout-dnd-utils": "static-1.11025",
  "ui-brand-identity-lib": "static-1.13924",
  "NamespacedHubStyle": "static-2.8905",
  "outpost": "static-1.4013",
  "sequences-client-types-lib": "static-1.7560",
  "customer-data-associations": "static-1.7148",
  "framework-data-table": "static-2.11435",
  "customer-data-rte": "static-1.32466",
  "cv-backend-services": "static-1.1504",
  "growth-onboarding-empty-states": "static-1.5378",
  "InboxConnectUtils": "static-4.14248",
  "payments-post-enroll-local-storage-lib": "static-1.4921",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7148",
  "commerce-tax-lib": "static-1.327",
  "property-description-translator": "static-1.3668",
  "FireAlarmUi": "static-1.4338",
  "sales-templates-service-types-lib": "static-1.4000",
  "commerce-analytics-service-client": "static-1.3466",
  "totals-ui-components": "static-1.23023",
  "ContentData": "static-1.67726",
  "layout-data-lib": "static-1.9350",
  "deal-intel-decorators": "static-1.1286",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27735",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3646",
  "advanced-menus-core": "static-1.14828",
  "advanced-menus-lib": "static-1.11801",
  "ui-memberships-settings-lib": "static-1.33450",
  "deal-intel-utils": "static-1.1290",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14827",
  "simple-menus-lib": "static-1.16344"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11586",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.446",
  "dashboard-client-types": "/dashboard-client-types/static-1.233",
  "data-fetching-client": "/data-fetching-client/static-1.9487",
  "foundations-components": "/foundations-components/static-1.7541",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.566",
  "foundations-theming": "/foundations-theming/static-1.4221",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7815",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9496",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11242",
  "I18n": "/I18n/static-7.1572",
  "jasmine-runner": "/jasmine-runner/static-1.6282",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11646",
  "quartz": "/quartz/static-1.6748",
  "react-dlb": "/react-dlb/static-1.72",
  "react-rhumb": "/react-rhumb/static-1.16460",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2672",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8497",
  "settings-ui-lib": "/settings-ui-lib/static-1.12332",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6749",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10950",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9356",
  "unified-auth": "/unified-auth/static-1.227",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.508",
  "usage-tracker": "/usage-tracker/static-1.7144",
  "usage-tracker-core": "/usage-tracker-core/static-1.6994",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7887",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6030",
  "integrations-lib": "/integrations-lib/static-1.15447",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18982",
  "property-management-iframe": "/property-management-iframe/static-1.12382",
  "quartz-config": "/quartz-config/static-1.526",
  "quartz-core": "/quartz-core/static-1.5967",
  "quartz-routing": "/quartz-routing/static-1.178",
  "quick-fetch": "/quick-fetch/static-1.3744",
  "react": "/react/static-7.179",
  "rpc-client-utils": "/rpc-client-utils/static-1.4444",
  "ts-schema": "/ts-schema/static-1.3913",
  "ui-universal-auth": "/ui-universal-auth/static-1.8713",
  "UIComponents": "/UIComponents/static-3.8189",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3238",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3025",
  "quartz-webpack": "/quartz-webpack/static-1.2972",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3810",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4646",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1937",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9237",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5182",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1233",
  "ui-fonts": "/ui-fonts/static-1.504",
  "ui-images": "/ui-images/static-2.1094",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2704",
  "foundations-theming-base": "/foundations-theming-base/static-1.3206",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.711",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2926",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4136",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8369",
  "ai-rendering-library": "/ai-rendering-library/static-1.9333",
  "chirp-fetch": "/chirp-fetch/static-1.1692",
  "connections-embed-lib": "/connections-embed-lib/static-1.647",
  "copilot-toolkit": "/copilot-toolkit/static-1.10556",
  "laboratory-lib": "/laboratory-lib/static-3.6970",
  "marketplace-embed": "/marketplace-embed/static-1.21510",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8878",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18938",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13153",
  "sanitize-text": "/sanitize-text/static-1.7950",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8506",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5558",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4830",
  "wootric-nps": "/wootric-nps/static-1.6793",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4459",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3965",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66564",
  "cssUtils": "/cssUtils/static-1.734",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11550",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10019",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10181",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7134",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17515",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4331",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5024",
  "quartz-i18n": "/quartz-i18n/static-1.423",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3541",
  "customer-data-objects": "/customer-data-objects/static-1.7459",
  "property-translator": "/property-translator/static-1.5222",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7734",
  "hs-promise-utils": "/hs-promise-utils/static-1.5403",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4691",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12862",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5398",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7598",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4284",
  "superstore": "/superstore/static-1.4580",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9957",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7472",
  "hub-http-janus": "/hub-http-janus/static-1.796",
  "hubspotter-http": "/hubspotter-http/static-1.4487",
  "immutable-less": "/immutable-less/static-1.4464",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16389",
  "nav-meta": "/nav-meta/static-1.28935",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10046",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17675",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3684",
  "property-management-common": "/property-management-common/static-1.4669",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8854",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.484",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.423",
  "quartz-head": "/quartz-head/static-1.413",
  "quartz-test": "/quartz-test/static-1.423",
  "quartz-tracking": "/quartz-tracking/static-1.127",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20358",
  "ContentUtils": "/ContentUtils/static-1.67651",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2296",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38941",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12817",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12955",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13577",
  "ExportDialog": "/ExportDialog/static-6.10196",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40681",
  "reporting-snowflake": "/reporting-snowflake/static-1.55182",
  "reporting-ui-components": "/reporting-ui-components/static-2.63835",
  "reporting-visualizations": "/reporting-visualizations/static-1.58640",
  "ui-addon-teams": "/ui-addon-teams/static-1.21257",
  "magpie-lib": "/magpie-lib/static-1.5403",
  "magpie-types": "/magpie-types/static-1.4863",
  "simple-logging-lib": "/simple-logging-lib/static-1.2860",
  "navigation-components": "/navigation-components/static-1.17298",
  "ai-studio-lib": "/ai-studio-lib/static-1.11027",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10288",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7799",
  "ui-tool-access": "/ui-tool-access/static-1.9954",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8029",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5561",
  "usage-tracker-public": "/usage-tracker-public/static-1.6955",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3426",
  "persist-promise": "/persist-promise/static-1.3518",
  "reference-resolvers": "/reference-resolvers/static-1.7970",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3754",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.150",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2809",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2212",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "atom": "/atom/static-1.4879",
  "purchase-motions-components": "/purchase-motions-components/static-1.5495",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1361",
  "crm-component-utils": "/crm-component-utils/static-1.38503",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5682",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6683",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7904",
  "navigation-messaging": "/navigation-messaging/static-1.6625",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9494",
  "cms-field-types": "/cms-field-types/static-1.4616",
  "content-icons-ui": "/content-icons-ui/static-1.2156",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7057",
  "crm-message-bus": "/crm-message-bus/static-1.42395",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21376",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9633",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4539",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3842",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6588",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.783",
  "onboarding-tours": "/onboarding-tours/static-1.16275",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13081",
  "academy-common-lib": "/academy-common-lib/static-1.13037",
  "content-assistance-lib": "/content-assistance-lib/static-1.7462",
  "dashboard-lib": "/dashboard-lib/static-1.80666",
  "file-manager-components": "/file-manager-components/static-1.22916",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17632",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17624",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19485",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8501",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4575",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10723",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8838",
  "user-context": "/user-context/static-1.4909",
  "growth-payments-core": "/growth-payments-core/static-1.24754",
  "reporting-plugins": "/reporting-plugins/static-1.9996",
  "reporting-reports": "/reporting-reports/static-1.66242",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.535",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28872",
  "react-codemirror": "/react-codemirror/static-1.10436",
  "apps-service-types": "/apps-service-types/static-1.3687",
  "oauth-service-types": "/oauth-service-types/static-1.4054",
  "onboarding-scopes": "/onboarding-scopes/static-1.6273",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4489",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7501",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14598",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8591",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4323",
  "nav-client-types": "/nav-client-types/static-1.2167",
  "purchase-motions-api": "/purchase-motions-api/static-1.5498",
  "signup-constants": "/signup-constants/static-1.18425",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3724",
  "card-properties-lib": "/card-properties-lib/static-1.43550",
  "crm-actions": "/crm-actions/static-1.6112",
  "crm-cards-data": "/crm-cards-data/static-1.1229",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42949",
  "customer-data-properties": "/customer-data-properties/static-1.50826",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8823",
  "customer-data-tracking": "/customer-data-tracking/static-1.6692",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3632",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3973",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3526",
  "external-options-client-types": "/external-options-client-types/static-1.3993",
  "react-dnd-compat": "/react-dnd-compat/static-1.4430",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5168",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2882",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1315",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.341",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7338",
  "academy-service-client": "/academy-service-client/static-1.3490",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27969",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8194",
  "video-components-external": "/video-components-external/static-1.10595",
  "video-data-lib": "/video-data-lib/static-1.34253",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8378",
  "payment-link-components": "/payment-link-components/static-1.22967",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9698",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23929",
  "viral-links-lib": "/viral-links-lib/static-1.6845",
  "data-token-picker": "/data-token-picker/static-1.16057",
  "FileManagerLib": "/FileManagerLib/static-1.38556",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5054",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17029",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8302",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.200",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3005",
  "crm_data": "/crm_data/static-4.91244",
  "crm-links": "/crm-links/static-1.6076",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45444",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15067",
  "crm-fe-perf": "/crm-fe-perf/static-1.22715",
  "calling-global-api": "/calling-global-api/static-1.63704",
  "calling-internal-common": "/calling-internal-common/static-1.31104",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65086",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57380",
  "commerce-products-lib": "/commerce-products-lib/static-1.8886",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.488",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4057",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.443",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48010",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3795",
  "property-value-citations": "/property-value-citations/static-1.1440",
  "pulse": "/pulse/static-1.322",
  "smart-property-lib": "/smart-property-lib/static-1.5949",
  "tiered-pricing": "/tiered-pricing/static-1.844",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10804",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1343",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6393",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11489",
  "content-media-compositions": "/content-media-compositions/static-2.15496",
  "media-bridge-lib": "/media-bridge-lib/static-1.18580",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5734",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4896",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3478",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21322",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3654",
  "audio-components": "/audio-components/static-1.5625",
  "FileManagerCore": "/FileManagerCore/static-1.38415",
  "FileManagerImages": "/FileManagerImages/static-1.36067",
  "video-components": "/video-components/static-1.12598",
  "crm_universal": "/crm_universal/static-1.21675",
  "customer-data-email": "/customer-data-email/static-1.17685",
  "calling-error-reporting": "/calling-error-reporting/static-1.31110",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36528",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38884",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18527",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11232",
  "customer-data-content": "/customer-data-content/static-1.26887",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54060",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20891",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17170",
  "project-storage": "/project-storage/static-1.4543",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71240",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5333",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5139",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9579",
  "policy-lib": "/policy-lib/static-1.6596",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10848",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6350",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.275",
  "commerce-permissions": "/commerce-permissions/static-1.568",
  "products-iframe-lib": "/products-iframe-lib/static-1.7343",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9878",
  "directed-graph": "/directed-graph/static-1.746",
  "event-emitter": "/event-emitter/static-1.757",
  "react-tinymce": "/react-tinymce/static-1.54647",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9642",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53773",
  "tinymce-plugins": "/tinymce-plugins/static-1.56887",
  "tinymce-themes": "/tinymce-themes/static-1.55743",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4342",
  "video-embed": "/video-embed/static-1.35087",
  "social-insights-client-types": "/social-insights-client-types/static-1.21375",
  "sequences-lib": "/sequences-lib/static-1.7703",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10157",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17942",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36461",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9816",
  "utility-belt": "/utility-belt/static-1.2350",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22060",
  "products-ui-components": "/products-ui-components/static-1.39405",
  "quotes-client-types": "/quotes-client-types/static-1.37329",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79960",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8917",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6739",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54076",
  "commerce-products-api": "/commerce-products-api/static-1.1971",
  "SafeStorage": "/SafeStorage/static-1.4214",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56134",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101917",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35052",
  "sales-views-client-types": "/sales-views-client-types/static-1.4097",
  "hub-http-contrib": "/hub-http-contrib/static-1.2853",
  "interframe": "/interframe/static-3.4599",
  "tinymce-data": "/tinymce-data/static-1.39858",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5023",
  "layout-dnd-components": "/layout-dnd-components/static-1.12050",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11025",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13924",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8905",
  "outpost": "/outpost/static-1.4013",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7560",
  "customer-data-associations": "/customer-data-associations/static-1.7148",
  "framework-data-table": "/framework-data-table/static-2.11435",
  "customer-data-rte": "/customer-data-rte/static-1.32466",
  "cv-backend-services": "/cv-backend-services/static-1.1504",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5378",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14248",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4921",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7148",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.327",
  "property-description-translator": "/property-description-translator/static-1.3668",
  "FireAlarmUi": "/FireAlarmUi/static-1.4338",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4000",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3466",
  "totals-ui-components": "/totals-ui-components/static-1.23023",
  "ContentData": "/ContentData/static-1.67726",
  "layout-data-lib": "/layout-data-lib/static-1.9350",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1286",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27735",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3646",
  "advanced-menus-core": "/advanced-menus-core/static-1.14828",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11801",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33450",
  "deal-intel-utils": "/deal-intel-utils/static-1.1290",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14827",
  "simple-menus-lib": "/simple-menus-lib/static-1.16344"
}
};
